/**
 * Provides data for the SelectedItemChanged event.
*/
var IgrSelectedItemChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrSelectedItemChangedEventArgs() {
    }
    Object.defineProperty(IgrSelectedItemChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrSelectedItemChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrSelectedItemChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrSelectedItemChangedEventArgs.prototype, "oldItem", {
        /**
         * The previously selected item.
        */
        get: function () {
            return this.i.oldItem;
        },
        set: function (v) {
            this.i.oldItem = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSelectedItemChangedEventArgs.prototype, "newItem", {
        /**
         * The newly selected item.
        */
        get: function () {
            return this.i.newItem;
        },
        set: function (v) {
            this.i.newItem = v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrSelectedItemChangedEventArgs;
}());
export { IgrSelectedItemChangedEventArgs };
